const SECRET_PATTERN = /^[A-Za-z0-9_-]{43}$/u;

/** Standard base64 to URL-safe base64 without padding, for the invite fragment. */
export function toBase64Url(standard: string): string {
  return standard.replace(/\+/gu, "-").replace(/\//gu, "_").replace(/=+$/u, "");
}

/** Reverses toBase64Url and restores padding. */
export function fromBase64Url(urlSafe: string): string {
  const standard = urlSafe.replace(/-/gu, "+").replace(/_/gu, "/");
  const remainder = standard.length % 4;
  return remainder === 0 ? standard : standard + "=".repeat(4 - remainder);
}

/** Fragment for an invite link. The secret stays after "#", so browsers never send it to the server. */
export function inviteFragment(secretB64: string): string {
  return `#${toBase64Url(secretB64)}`;
}

/** Reads the invite secret from a location hash. Returns standard base64, or undefined when malformed. */
export function readInviteSecret(hash: string): string | undefined {
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  if (!SECRET_PATTERN.test(raw)) {
    return undefined;
  }
  return fromBase64Url(raw);
}
